import { Checkbox } from '@consta/uikit/Checkbox'
import { Layout } from '@consta/uikit/Layout'
import { Modal } from '@consta/uikit/Modal'
import { Select } from '@consta/uikit/Select'
import type { ChangeEventHandler, FC } from 'react'
import { useEffect, useState } from 'react'

import css from './AddingFilesModal.css'
import { AddingFilesModalFooter as ModalFooter } from './AddingFilesModalFooter'
import { AddingFilesModalHeader as ModalHeader } from './AddingFilesModalHeader'
import type { AddingFilesVSPModalPropsType as Props, FormDataVSPType } from './types'

const dummyFn = () => undefined

export const AddingFilesVSPModal: FC<Props> = ({
  fileName,
  objectName,
  isModalOpen,
  wellItems,
  onCancel,
  onSave,
}) => {
  const [formData, setFormData] = useState<FormDataVSPType | undefined>()
  const isDisabledOnSaveBtn = !formData?.wellId

  useEffect(() => {
    if (wellItems[0]?.key) {
      setFormData({
        objectName,
        wellId: wellItems[0].key,
        isNegativeZ: false,
        isNegativeTwt: false,
      })
    }
  }, [objectName, wellItems])

  const onZValueChange: ChangeEventHandler<HTMLInputElement> = ({ target }) => {
    setFormData({
      ...formData,
      isNegativeZ: target.checked,
    })
  }

  const onTwtValueChange: ChangeEventHandler<HTMLInputElement> = ({ target }) => {
    setFormData({
      ...formData,
      isNegativeTwt: target.checked,
    })
  }

  return (
    <Modal
      isOpen={isModalOpen}
      hasOverlay={true}
      rootClassName={css.rootContainer}
      className={css.window}
      onClickOutside={onCancel}
      onEsc={onCancel}>
      <ModalHeader fileName={fileName} />

      <Layout direction="column" className={css.wellPart}>
        <Select
          name="well"
          placeholder="Выберите значение"
          label="Скважина"
          className={css.wellSelect}
          size="s"
          dropdownClassName={css.selectDropdown}
          disabled={true}
          items={wellItems}
          value={wellItems.find(({ key }) => formData?.wellId === key)}
          getItemKey={item => item.key}
          getItemLabel={item => item.label}
          onChange={dummyFn}
        />
        <Checkbox
          label="Отрицательные значения по глубине (Z)"
          checked={formData?.isNegativeZ}
          className={css.negativeZText}
          onChange={onZValueChange}
        />
        <Checkbox
          label="Отрицательные значения по времени (TWT)"
          checked={formData?.isNegativeTwt}
          onChange={onTwtValueChange}
        />
      </Layout>

      <ModalFooter
        isViewSaveAllBtn={false}
        isDisabledOnSaveBtn={isDisabledOnSaveBtn}
        onCancel={onCancel}
        onSave={() => {
          onSave(formData)
        }}
      />
    </Modal>
  )
}
